import { trans } from "@mongez/localization";
import { Button } from "~/design-system/components";
import { useFilters } from "../../hooks";

type ApplyFiltersButtonProps = {
  onClick?: () => void;
};

export function ApplyFiltersButton({ onClick }: ApplyFiltersButtonProps) {
  const { applyFilters } = useFilters();

  const handleClick = () => {
    applyFilters();
    onClick?.();
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      className="bg-primary-light w-full justify-center rounded-full border py-3 font-semibold uppercase"
    >
      {trans("apply")}
    </Button>
  );
}
